/**
 * Shape of the per-app `SessionContextService` as consumed from tio-common.
 *
 * Each consuming app (tio-admin, tio-employee, tio-agent) provides its own
 * concrete class. The three classes don't agree on much — only `user` is
 * universally present — so every other field is typed optional to match
 * reality. Tio-common code that reads an optional field is implicitly
 * opting into app-specific behaviour and must guard against `undefined`.
 *
 * Fields intentionally NOT on this interface:
 *   isTioAdmin — no app service exposes this; use `user.isTioAdmin` instead.
 */
import type Service from '@ember/service';
import type UserModel from 'tio-data/models/user';
import type EmployeeModel from 'tio-data/models/employee';
import type RoleViewModel from 'tio-data/models/role-view';

export default interface SessionContextService extends Service {
  user: UserModel;
  // tio-admin and tio-employee expose this. tio-agent does not.
  canEditTasApplication?: boolean;
  // tio-employee only.
  currentEmployee?: EmployeeModel;
  // tio-employee only. Resolves to `undefined` when there is no active role.
  currentRole?: RoleViewModel;
  // tio-employee only.
  isLoaded?: boolean;
}
